import { z } from 'zod';
import { CONTENTFUL_ENGLISH_KEY } from '.';

const amountRegex = /^\d+(mg|g|ml)$/;
const cbdRegex = /^[<>]?(100|[1-9]?[0-9])(,[0-9]+)?$/;
const amountPerUnitRegex = /^\d+(mg|g|ml)(\s*\/\s*Stk\.)?$/;

export enum ContentfulProductType {
  Flower = 'Blüte',
  Hash = 'Haschisch',
  Vape = 'Vape',
  Oil = 'Öl',
  Edible = 'Edible',
}

export const contentfulProductSchema = z.object({
  metadata: z.any(),
  sys: z
    .object({
      id: z.string(),
      type: z.literal('Entry'),
      contentType: z.object({
        sys: z.object({
          id: z.literal('product'),
          linkType: z.literal('ContentType'),
          type: z.literal('Link'),
        }),
      }),
    })
    .passthrough(),

  fields: z.object({
    title: z.object({
      [CONTENTFUL_ENGLISH_KEY]: z.string(),
    }),
    thcLevel: z.object({
      [CONTENTFUL_ENGLISH_KEY]: z.number().int().min(1).max(3),
    }),
    price: z.object({
      [CONTENTFUL_ENGLISH_KEY]: z.number(),
    }),
    amount: z.object({
      [CONTENTFUL_ENGLISH_KEY]: z
        .string()
        .regex(amountRegex, 'Ungültiges Format – z. B. 5g oder 250ml'),
    }),
    thcPercentage: z
      .object({
        [CONTENTFUL_ENGLISH_KEY]: z.number().int().min(0).max(100),
      })
      .optional(),
    cbdPercentage: z
      .object({
        [CONTENTFUL_ENGLISH_KEY]: z
          .string()
          .regex(cbdRegex, 'Ungültiger CBD-Wert'),
      })
      .optional(),
    producer: z.object({
      [CONTENTFUL_ENGLISH_KEY]: z.string(),
    }),
    strainDominance: z
      .object({
        [CONTENTFUL_ENGLISH_KEY]: z.string(),
      })
      .optional(),
    type: z.object({
      [CONTENTFUL_ENGLISH_KEY]: z.nativeEnum(ContentfulProductType),
    }),
    amountPerUnit: z
      .object({
        [CONTENTFUL_ENGLISH_KEY]: z
          .string()
          .regex(
            amountPerUnitRegex,
            'Ungültiges Format – z. B. 500mg oder 2g/Stk.',
          ),
      })
      .optional(),
    image: z
      .object({
        [CONTENTFUL_ENGLISH_KEY]: z
          .object({
            sys: z
              .object({
                id: z.string(),
                type: z.union([z.literal('Link'), z.literal('Asset')]),
                linkType: z.string().optional(),
              })
              .passthrough(),

            fields: z.object({
              file: z.object({
                [CONTENTFUL_ENGLISH_KEY]: z.object({
                  url: z.string(),
                }),
              }),
            }),
          })
          .passthrough(),
      })
      .optional(),
  }),
});

export type ContentfulProduct = z.infer<typeof contentfulProductSchema>;

export const contentfulProductResDto = z.array(contentfulProductSchema);
export type ContentfulProductResDto = z.infer<typeof contentfulProductResDto>;
